import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { patchRequest, postRequest } from "../../axios";
import { SuccessNotificationMsg } from "../../utils/Notifications";
import { useTranslation } from "react-i18next";
import { confirmAlert } from "react-confirm-alert";
import { authUserData } from "../../utils/Helper";

const SelectAssignBuyer = ({
  assignToBuyer,
  assignBuyer,
  assignPurchaseRequisitionDetails,
  onBuyerChange,
}) => {
  const [tempBuyer, setTempBuyer] = useState(assignToBuyer || null); 
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const companyUserName = authUserData()?.company
    ? authUserData()?.first_name
    : null;
  const companyUserId = authUserData()?.company
    ? authUserData()?.user_id
    : null;
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;

  const {id, categoryId} = useParams();

  console.log('ieeeeed', id, "categoryId", categoryId);
  


  const toCapitalCase = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  useEffect(() => {
    if (assignToBuyer) {
      setTempBuyer(toCapitalCase(assignToBuyer));
    }
  }, [assignToBuyer]);

  const saveAssignToBuyer = async (value, id1) => {
    let buyer = null;
    let name = "";

    if (value === companyUserId) {
      buyer = value;

      try {
        await patchRequest(`purchase-requisition/${id1}/pr-assign-to-buyer/`, {
          pr_assign_to_buyer: value,
        });

        SuccessNotificationMsg(t(`PR assigned to yourself Successfully`));
        navigate(`/request-for-quotation/history`);
        setReload(!reload);
        setLoading(false);
        onBuyerChange(value);
      } catch (error) {
        console.error("Error updating assignee:", error);
      }
    } else {
      buyer = assignBuyer.find((user) => user.user_id === value);

      try {
        await patchRequest(`purchase-requisition/${id1}/pr-assign-to-buyer/`, {
          pr_assign_to_buyer: value,
        });

        SuccessNotificationMsg(
          t(`PR assigned to ${buyer.first_name} Successfully`)
        );

        navigate(`/request-for-quotation/history`);
        setReload(!reload);
        setLoading(false);
        onBuyerChange(value);
      } catch (error) {
        console.error("Error updating assignee:", error);
      }
    }
  };

    const handleFloatRFQFORApprovedDirectActionField = async (
      selectedRowIds = [],
      id = ""
    ) => {
      let ids = selectedRowIds;
      if (id) {
        ids.push(id);
      }
      try {
        let apiResponse = await postRequest(`float-rfq/`, {
          company: CompanyID,
          category_tree: parseInt(categoryId),
          purchase_requisition_master: [ids],
        });
  
        const responseId = apiResponse.data.data.id;
        navigate(`/request-for-quotation/add-rfq/${responseId}`);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    const handleFloatRFQValueDirect = async (value, id, selectedRowIds, name) => {
      try {
        await patchRequest(`purchase-requisition/${id}/pr-assign-to-buyer/`, {
          pr_assign_to_buyer: value,
        });
        if (value !== companyUserId) {
          let assignedEmployee = assignBuyer.find(
            (buyer) => buyer.user_id === value
          );
          SuccessNotificationMsg(
            t(`PR assigned to ${assignedEmployee.first_name} Successfully`)
          );
        } else {
          SuccessNotificationMsg(t(`PR assigned to yourself Successfully`));
        }
  
        handleFloatRFQFORApprovedDirectActionField(id);
  
        setReload(!reload);
        setLoading(false);
      } catch (error) {
        console.error("Error updating assignee:", error);
      }
    };

  const getBuyerName = (id) => {
    const buyer = assignBuyer.find((buyer) => buyer.user_id === id);
    return buyer ? buyer.first_name : "yourself";
  };
  // const handleSelectBuyerChange = (value, id, name) => {
  //   let buyerName = getBuyerName(value);

  //   setTempBuyer(value);

  //   confirmAlert({
  //     title: "Confirm",
  //     message: (
  //       <>
  //         Are you sure you want to assign <strong>{buyerName}</strong> to handle
  //         the PR?
  //       </>
  //     ),
  //     buttons: [
  //       {
  //         label: "Yes",
  //         onClick: () => {
  //           saveAssignToBuyer(value, assignPurchaseRequisitionDetails.id);
  //         },
  //       },
  //       {
  //         label: "No",
  //         onClick: () => {
  //           setTempBuyer(assignToBuyer); 
  //         },
  //       },
  //       {
  //         label: "Assign & Float RFQ",
  //         onClick: () =>
  //           handleFloatRFQValueDirect(
  //             value === "me" ? companyUserId : value,
  //             id,
  //             value === "me" ? id : 1,
  //             name
  //           ),
  //       },
  //     ],
  //   });
  // };
  
  const handleSelectBuyerChange = (value, id, name) => {
    let buyerName = getBuyerName(value);
  
    setTempBuyer(value);
  
    confirmAlert({
      title: (
        <div style={{ fontSize: "20px", fontWeight: "bold", color: "#094e8f", textAlign: "center" }}>
          Confirm Assignment
        </div>
      ),
      message: (
        <div style={{ fontSize: "16px", color: "#333", textAlign: "center" }}>
          Are you sure you want to assign <strong>{buyerName}</strong> to handle the PR?
        </div>
      ),
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            saveAssignToBuyer(value, assignPurchaseRequisitionDetails.id);
          },
          style: {
            backgroundColor: "#094e8f",
            color: "#fff",
            border: "none",
            padding: "12px 20px",
            fontSize: "16px",
            borderRadius: "5px",
            cursor: "pointer",
          },
        },
        {
          label: "No",
          onClick: () => {
            setTempBuyer(assignToBuyer); 
          },
          style: {
            backgroundColor: "#f1f1f1",
            color: "#000",
            border: "none",
            padding: "12px 20px",
            fontSize: "16px",
            borderRadius: "5px",
            cursor: "pointer",
          },
        },
        {
          label: "Assign & Float RFQ",
          onClick: () =>
            handleFloatRFQValueDirect(
              value === "me" ? companyUserId : value,
              id,
              value === "me" ? id : 1,
              name
            ),
          style: {
            backgroundColor: "#094e8f",
            color: "#fff",
            border: "none",
            padding: "12px 20px",
            fontSize: "16px",
            borderRadius: "5px",
            cursor: "pointer",
          },
        },
      ],
      overlayStyle: {
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      },
      titleStyle: {
        color: "#094e8f",
        fontSize: "24px",
        fontWeight: "bold",
        textAlign: "center",
      },
      messageStyle: {
        color: "#333",
        fontSize: "16px",
        textAlign: "center",
      },
      className: "custom-modal-design",
    });
  };
  
  const me = tempBuyer === companyUserName ? "Assign to me" : tempBuyer;

  return (
    <Select
      className="cust-selectBox"
      showArrow
      showSearch
      allowClear
      defaultValue={tempBuyer}
      value={me ? me : "Unassigned"}
      onChange={(e) => handleSelectBuyerChange(e, id, me)}
      filterOption={(input, option) =>
        (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
      }
    >
      <Select.Option key="01" value={companyUserId}>
        Assign to me
      </Select.Option>
      {assignBuyer?.map((option) => (
        <Select.Option key={option.user_id} value={option.user_id}>
          {option.first_name}
        </Select.Option>
      ))}
    </Select>
  );
};

SelectAssignBuyer.propTypes = {
  assignToBuyer: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), 
  assignBuyer: PropTypes.array.isRequired,
  assignPurchaseRequisitionDetails: PropTypes.object.isRequired,
  onBuyerChange: PropTypes.func.isRequired, 
};

export default SelectAssignBuyer;
